module.exports = __webpack_public_path__ + "img/09.ac9070ba.jpg";